import { create } from 'zustand';

interface SearchOverlayState {
  isOverlayOpen: boolean;
  isPageSearchBarVisible: boolean;
  openOverlay: () => void;
  closeOverlay: () => void;
  setPageSearchBarVisible: (visible: boolean) => void;
  reset: () => void;
}

const INITIAL_STATE = {
  isOverlayOpen: false,
  isPageSearchBarVisible: true,
};

export const useSearchOverlayStore = create<SearchOverlayState>((set) => ({
  ...INITIAL_STATE,

  openOverlay: () => {
    set((state) => {
      if (state.isPageSearchBarVisible) return state;

      return { ...state, isOverlayOpen: true };
    });
  },

  closeOverlay: () => {
    set((state) => ({ ...state, isOverlayOpen: false }));
  },

  setPageSearchBarVisible: (visible) => {
    set({ isPageSearchBarVisible: visible });
  },

  reset: () => {
    set(INITIAL_STATE);
  },
}));
